import { iconFactory } from '../iconFactory'

export const Pencil = iconFactory(
  'Pencil',
  ({ fill }) => (
    <path
      d="M14.7888 2.90099C15.0704 3.18261 15.0704 3.63755 14.7888 3.91918L13.4673 5.24066L10.7593 2.5327L12.0808 1.21122C12.3624 0.929593 12.8174 0.929593 13.099 1.21122L14.7888 2.90099ZM2 14V11.292L9.98667 3.30537L12.6946 6.01333L4.70796 14H2Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
